"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingCustomerSalesOrderDetails = void 0;
const React = require("react");
const time_1 = require("../../../../../../helpers/time");
const OrderType_1 = require("../../OrderType");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "PendingCustomerSalesOrderDetails");
const PendingCustomerSalesOrderDetails = ({ salesOrder }) => {
    const { type, predictedCompletionTime, retailLocation: { title } } = salesOrder;
    return (React.createElement("div", { className: css("") },
        React.createElement("div", { className: css("restaurant") }, title),
        React.createElement(OrderType_1.OrderType, { orderType: type }),
        React.createElement("div", { className: css("due") },
            "Due ",
            (0, time_1.timestampLabel)(predictedCompletionTime))));
};
exports.PendingCustomerSalesOrderDetails = PendingCustomerSalesOrderDetails;
//# sourceMappingURL=index.js.map